<div class="fed-landing-page">
  <header class="fed-landing-page__header container">
    <app-logo
      class="fed-landing-page__logo"
      height="28"
      [name]="logoType.OrganizerDark"
      [alt]="'a11y.fed_landing.logo' | translate"
    ></app-logo>
  </header>

  <main class="container fed-landing-page__container">
    <picture class="fed-landing-page__picture">
      <source
        srcset="/assets/organizer/fed-landing/background.jpg"
        [media]="mdScreenSize"
      />
      <img
        class="fed-landing-page__image"
        src="/assets/organizer/fed-landing/mobile.jpg"
        [alt]="'a11y.fed_landing.img' | translate"
      />
    </picture>

    <div class="fed-landing-page__content">
      <h1 class="fed-landing-page__title">
        {{ 'organizer.fed_landing.title' | translate }}
      </h1>

      <button
        class="fed-landing-page__link"
        app-vtmn-play-button
        type="button"
        [type]="ctaButtonType.Button"
        [size]="buttonSize"
        (click)="FEDLogin()"
      >
        {{ 'organizer.fed_landing.button' | translate }}
      </button>
    </div>
  </main>

  <app-organizer-shared-footer
    class="fed-landing-page__footer"
  ></app-organizer-shared-footer>
</div>
